import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

function isAnnotationEntityGroupKey(hash: string): boolean {
  return hash.startsWith("annotation.");
}

function isContentTemplateInstanceEntityGroupKey(hash: string): boolean {
  return hash.startsWith("contentTemplateInstance.");
}

const migration: DocMigration = {
  id: "20260624_split_annotation_groups",
  description: "Split groups that contain both annotations and drawing template instances",
  apply(json: any) {
    // This fixes a leftover issue from annotation catalog to drawing template migration.
    // It splits groups that contain both annotations and drawing template instances.
    // migration_20260508_annotation_catalog_to_drawing_template.ts
    const groups = json.groups ?? {};
    const entityGroups = json.entityGroups ?? {};

    json.groups = groups;
    json.entityGroups = entityGroups;

    const mixedGroupIds = new Set<string>();
    const groupHasAnnotationMember = new Map<string, boolean>();
    const groupHasInstanceMember = new Map<string, boolean>();

    for (const [hash, groupId] of Object.entries(entityGroups) as [string, string][]) {
      if (isAnnotationEntityGroupKey(hash)) {
        groupHasAnnotationMember.set(groupId, true);
      } else if (isContentTemplateInstanceEntityGroupKey(hash)) {
        groupHasInstanceMember.set(groupId, true);
      }
    }

    for (const groupId of groupHasAnnotationMember.keys()) {
      if (groupHasInstanceMember.get(groupId)) {
        mixedGroupIds.add(groupId);
      }
    }

    const oldContentTemplateInstanceGroupToNewGroup = new Map<string, string>();

    for (const groupId of mixedGroupIds) {
      const existingGroup = groups[groupId];
      if (!existingGroup) {
        continue;
      }
      if (existingGroup.isBuiltIn === true) {
        // Not expected to happen.
        continue;
      }
      const newGroupId = uid();
      const newGroup: any = {
        entityType: "GROUP",
        id: newGroupId,
        name: existingGroup.name,
        isDeletable: existingGroup.isDeletable ?? true,
        sortIndex: existingGroup.sortIndex ?? 0,
      };

      if (existingGroup.disabled !== undefined) {
        newGroup.disabled = existingGroup.disabled;
      }
      if (existingGroup.exclusive !== undefined) {
        newGroup.exclusive = existingGroup.exclusive;
      }

      groups[newGroupId] = newGroup;

      oldContentTemplateInstanceGroupToNewGroup.set(groupId, newGroupId);
    }

    for (const [hash, memberGroupId] of Object.entries(entityGroups) as [string, string][]) {
      if (
        isContentTemplateInstanceEntityGroupKey(hash) &&
        oldContentTemplateInstanceGroupToNewGroup.has(memberGroupId)
      ) {
        entityGroups[hash] = oldContentTemplateInstanceGroupToNewGroup.get(memberGroupId);
      }
    }

    return json;
  },
};

export default migration;
